export enum ExportType {
    CSV = 'CSV',
    EXCEL = 'EXCEL',
    JSON = 'JSON',
    PDF = 'PDF',
    XML = 'XML',
}
